module.exports = __webpack_public_path__ + "img/edit.706afa1b.svg";